<template>
  <section aria-labelledby="app-settings-title">
    <h2
      id="app-settings-title"
      class="text-h5 mb-4"
    >
      App Settings
    </h2>
    <v-alert
      v-if="error"
      type="error"
      outlined
    >
      {{ error }}
      <v-btn
        v-if="!settings"
        text
        small
        :loading="loading"
        @click="load"
      >
        Try again
      </v-btn>
    </v-alert>
    <v-alert
      v-if="message"
      type="success"
      outlined
      dismissible
    >
      {{ message }}
    </v-alert>
    <v-progress-linear
      v-if="loading"
      indeterminate
      aria-label="Loading app settings"
    />
    <v-card
      v-if="settings"
      outlined
      class="pa-5 app-settings-card"
    >
      <h3 class="text-h6 mb-2">
        Affiliate applications
      </h3>
      <v-switch
        v-model="required"
        color="primary"
        label="Require a paid subscription to apply as an affiliate"
        :disabled="busy || loading"
        hide-details
        class="mt-2 mb-3"
      />
      <p v-if="required">
        New applicants must have an active Personal or Plus subscription. Later plan changes do not affect existing applications, affiliate status or commissions.
      </p>
      <p v-else>
        Free accounts can apply. Administrator approval is required before an affiliate link becomes available.
      </p>
      <v-btn
        color="primary"
        :loading="busy"
        :disabled="!changed || loading"
        @click="save"
      >
        Save settings
      </v-btn>
    </v-card>
  </section>
</template>
<script>
import referrals from '@/services/referrals'

export default {
  name: 'AppSettings',
  data: () => ({
    settings: null, required: false, loading: false, busy: false, error: '', message: '',
  }),
  computed: {
    changed() { return this.settings && this.required !== this.settings.affiliate_subscription_required },
  },
  mounted() { this.load() },
  methods: {
    async load() {
      this.loading = true; this.error = ''
      try {
        this.settings = await referrals.admin('app-settings')
        this.required = this.settings.affiliate_subscription_required
      } catch (error) {
        this.error = (error.response && error.response.data.message) || 'App settings are temporarily unavailable.'
      } finally { this.loading = false }
    },
    async save() {
      if (!this.changed || this.busy) return
      this.busy = true; this.error = ''; this.message = ''
      try {
        this.settings = await referrals.updateSettings({ affiliate_subscription_required: this.required })
        this.required = this.settings.affiliate_subscription_required
        this.message = 'App settings saved.'
      } catch (error) {
        this.error = (error.response && error.response.data.message) || 'Could not save app settings.'
      } finally { this.busy = false }
    },
  },
}
</script>
<style scoped>
.app-settings-card { max-width: 840px; }
</style>
